import { render, staticRenderFns } from "./SiderBar.vue?vue&type=template&id=3f7beece&scoped=true&"
import script from "./SiderBar.vue?vue&type=script&lang=js&"
export * from "./SiderBar.vue?vue&type=script&lang=js&"
import style0 from "./SiderBar.vue?vue&type=style&index=0&id=3f7beece&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7beece",
  null
  
)

export default component.exports